"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendedProductsView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const ProductTileView_1 = require("../../productTile/views/ProductTileView");
const Wrapper = app_1.styled.div `
  ${(theme) => theme.flexCenter};
  flex-direction: column;
`;
const Label = (0, app_1.styled)(app_1.Text) `
  padding-bottom: ${(theme) => theme.spacing.large};
`;
const StyledGrid = (0, app_1.styled)(ui_1.Grid) `
  height: 28rem;
  width: 100%;
  gap: ${(theme) => theme.spacing.big};
  @media ${app_1.notDesktop} {
    height: unset;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(3, minmax(0, 1fr));

    > a {
      display: flex;
      flex-direction: column;
      align-items: center;
      > h4 {
        position: unset;
      }
    }
  }
`;
function RecommendedProductsView({ className, renderNameTag, label, loading, products, }) {
    const arr = loading ? [null, null, null] : products;
    return ((0, jsx_runtime_1.jsxs)(Wrapper, Object.assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", spacing: "extraSmall" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: renderNameTag })), (0, jsx_runtime_1.jsx)(Label, Object.assign({ tag: "h3" }, { children: label }))] })), (0, jsx_runtime_1.jsx)(StyledGrid, Object.assign({ templateColumns: "repeat(3, minmax(0, 1fr))", templateRows: "minmax(0, 1fr)" }, { children: arr === null || arr === void 0 ? void 0 : arr.map((p, i) => {
                    var _a;
                    return ((0, jsx_runtime_1.jsx)(ProductTileView_1.ProductTileView, { product: p, variant: "small", loading: loading }, (_a = p === null || p === void 0 ? void 0 : p.id) !== null && _a !== void 0 ? _a : i));
                }) }))] })));
}
exports.RecommendedProductsView = RecommendedProductsView;
